export default function WhyGenieAiX() {
  const features = [
    'Designed for regulated and high-trust industries',
    'No black-box automation',
    'No generic AI tools',
    'Clear ownership and accountability',
    'Professional presentation at every touchpoint',
    'Proven track record with established firms'
  ];

  return (
    <section className="bg-white py-28">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="flex items-center gap-20">
          <div className="w-[40%] pl-20">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-[0.15em] mb-4 block">Why GenieAiX</span>
            <h2 className="text-6xl font-bold text-gray-900 leading-tight mb-10" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Built for trust, not trends
            </h2>
            <div className="relative h-[380px] rounded-2xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/cc859e9d8920b1cf2418563f3b8a53c6.jpg"
                alt="Trust and professionalism"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-2 gap-x-8 gap-y-10">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#2B6FED] text-2xl"></i>
                  </div>
                  <span className="text-lg text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 bg-blue-50 rounded-2xl py-8 px-12">
          <p className="text-center text-xl text-gray-800 italic" style={{ fontFamily: 'Crimson Pro, serif' }}>
            We respect tradition—while enabling progress.
          </p>
        </div>
      </div>
    </section>
  );
}
